import {NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatGridListModule} from '@angular/material/grid-list';
import {TextFieldModule} from '@angular/cdk/text-field';
import { MatTreeModule } from '@angular/material/tree';
import {MatBadgeModule} from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import {MatChipsModule} from '@angular/material/chips';
import {MatCardModule} from '@angular/material/card';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatMenuModule} from '@angular/material/menu';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatIconModule} from '@angular/material/icon';
import {MatRadioModule} from '@angular/material/radio';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatTabsModule} from '@angular/material/tabs';
import {MatListModule} from '@angular/material/list';
import {MatDividerModule} from '@angular/material/divider';
import {MatStepperModule} from '@angular/material/stepper';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { HighchartsChartModule } from 'highcharts-angular';




@NgModule({
  declarations: [],
  imports: [
    MatChipsModule,
    CommonModule,
    MatSnackBarModule,
    MatInputModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatExpansionModule,
    MatButtonModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatDialogModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatTooltipModule,
    MatMenuModule,
    MatToolbarModule,
    MatSidenavModule,
    MatIconModule,
    MatNativeDateModule,
    MatRadioModule,
    MatButtonToggleModule,
    MatTabsModule,
    MatDividerModule,
    MatListModule,
    MatStepperModule,
    MatProgressBarModule,
    MatGridListModule,
    TextFieldModule,
    MatTreeModule,
    MatBadgeModule,   
    HighchartsChartModule 
  ],
  exports:[MatBadgeModule,MatTreeModule,TextFieldModule,MatGridListModule,MatProgressBarModule,MatStepperModule,MatListModule,MatDividerModule,MatTabsModule,MatButtonToggleModule,MatChipsModule,MatSnackBarModule, MatInputModule, MatCardModule, MatProgressSpinnerModule, MatTableModule, MatSortModule, MatPaginatorModule, MatSelectModule, MatAutocompleteModule, MatExpansionModule, MatButtonModule, MatCheckboxModule, MatSlideToggleModule, MatDialogModule, MatFormFieldModule, MatDatepickerModule, MatTooltipModule, MatMenuModule, MatToolbarModule, MatSidenavModule, MatIconModule, MatNativeDateModule, MatRadioModule]
})
export class MaterialModule {}